<template lang="html">
      <div class="newsletter" :class="{ active: isActive, complete: checkOut }">
            <div class="cart-half flex f-c">
                  <div class="flex li jc-sb p-b">
                        <h1 class="lundi">Newsletter</h1>
                        <div v-if="!checkOut" class="cart-close link lundi" @click="closeNewsletter" >
                              Close
                        </div>
                  </div>
                  <div class="cart-table f-1 flex f-c jc-sb">
                        <mailchimp-subscribe
                              url="https://lundipiscine.us4.list-manage.com/subscribe/post-json"
                              user-id="1b728da305892bb6503c911d8"
                              list-id="427695fb24"
                              @error="onError"
                              @success="onSuccess"
                        >
                              <template v-slot="{ subscribe, setEmail, error, success, loading }">
                                    <form @submit.prevent="subscribe" id="subscription-form" class="flex f-c" >
                                          <div class="li flex">
                                                <div class="sli">Email*</div>
                                                <div class="sli f-1">
                                                <input type="email" @input="setEmail($event.target.value)" />
                                                </div>
                                          </div>
                                          <div class="li flex">
                                                <button type="submit" class="subscribe-button b-r sli">Subscribe</button>
                                          </div>
                                          <div v-if="loading" class="li flex jc-c">
                                                <div class="sli">Loading</div>      
                                          </div>
                                          <div v-if="error || success" class="li flex jc-c">
                                                <div class="sli" v-if="error">
                                                      Oups. Une erreur s'est produite.
                                                </div>
                                                <div class="sli" v-if="success">
                                                      Merci beaucoup
                                                </div>
                                          </div>
                                    </form>
                              </template>
                        </mailchimp-subscribe>
                  </div>
            </div>
      </div>
</template>

<script>
// MAILCHIMP_API="8e5ed212280d9e1a245ede6bf6bcc92d-us4"
// LIST_ID="427695fb24"
/* eslint no-console: ["error", { allow: ["log"] }] */
import MailchimpSubscribe from 'vue-mailchimp-subscribe'

export default {
      data() {
            return {
                  isActive: false,
                  checkOut: false,
            };
      },
      components: {
            MailchimpSubscribe,
      },
      mounted() {
            this.$root.$on("openNewsletter", this.openNewsletter);
            this.$root.$on("closeNewsletter", this.closeNewsletter);
      },
      methods: {
            onError(error) {
                  console.log(error);
                  this.error = true;
                  this.success = false;
            },
            onSuccess() {
                  console.log("success");
                  this.success = true;
                  this.error = false;
            },
            openNewsletter() {
                  this.isActive = true;
                  this.$root.$emit("closeCart");
            },
            closeNewsletter() {
                  this.isActive = false;
                  this.checkOut = false;
                  this.success = false;
                  this.email = null;
                  this.error = false;
            }
      }
};
</script>

<style lang="scss" scoped>
.subscribe-button {
  appearance: none;
  border: 0;
  outline: none;
  font-family: "Liga", Arial, sans-serif;
  font-size: var(--fs);
  line-height: var(--lh);
  background: black;
  color: var(--orange);
  padding: 0;
  transition: background-color 0.5s;
  cursor: pointer;
  &:hover {
    background: white;
  }
}
.newsletter {
  position: fixed;
  top: 0;
  right: 0;
  width: 500px;
  height: 100%;
  background: var(--orange);
  padding: var(--pad);
  transform: translate3d(100%, 0, 0);
  transition: transform 0.5s;
  z-index: 10;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: var(--lh);
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
  &.active {
    transform: translate3d(0%, 0, 0);
  }
  .cart-half {
    grid-column: span 2;
  }
}
</style>
